/*
 * Free-shipping bar glints.
 *
 * Ambient, premium "light catching jewellery" effect on the reached free-shipping bar:
 * small gold four-point glints orbit around the "Kostenloser Versand" text continuously
 * (with small natural pauses) as long as the cart qualifies. Works on both surfaces
 * (cart page + drawer) and re-attaches itself whenever the bar is re-rendered.
 *
 * Pairs with free-shipping-celebration.js — that fires the one-shot smiley confetti at the
 * moment of crossing; this is the lasting shimmer on the bar.
 *
 * Respects prefers-reduced-motion (no glints at all).
 */
(function () {
  if (window.__waldFsBarGlints) return;
  window.__waldFsBarGlints = true;

  var REACHED = '.cart-drawer__shipping-bar--reached';
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  function injectCss() {
    if (document.getElementById('wald-fs-glints-css')) return;
    var style = document.createElement('style');
    style.id = 'wald-fs-glints-css';
    style.textContent =
      '.wald-fs-glint-layer{position:absolute;inset:0;pointer-events:none;z-index:2;}' +
      '.wald-fs-glint{position:absolute;pointer-events:none;will-change:transform,opacity;' +
      'background:radial-gradient(circle,#fff 0%,#F6E3A0 48%,rgba(246,227,160,0) 74%);' +
      'clip-path:polygon(50% 0%,60% 40%,100% 50%,60% 60%,50% 100%,40% 60%,0% 50%,40% 40%);}' +
      '@keyframes waldFsGlint{0%{opacity:0;transform:translate(-50%,-50%) scale(0) rotate(0deg)}' +
      '30%{opacity:1}50%{transform:translate(-50%,-50%) scale(1) rotate(18deg)}' +
      '100%{opacity:0;transform:translate(-50%,-50%) scale(0) rotate(38deg)}}';
    document.head.appendChild(style);
  }

  function spawnGlint(bar, layer, angle) {
    var w = bar.clientWidth;
    var h = bar.clientHeight;
    if (!w || !h) return;
    var text = bar.querySelector('.cart-drawer__shipping-text');
    var tw = text ? text.offsetWidth : w * 0.5;
    var cx = w / 2;
    var cy = h / 2;
    // A flat, wide ellipse hugging the word: glints sweep left/right around it with a slight
    // vertical arc, staying inside the thin bar (which clips overflow).
    var rx = Math.min(tw / 2 + 16, w / 2 - 6);
    var ry = Math.max(6, h / 2 - 1);
    var rad = (angle * Math.PI) / 180;
    var x = cx + Math.cos(rad) * rx;
    var y = cy + Math.sin(rad) * ry;
    var size = (8 + Math.random() * 5).toFixed(1);
    var el = document.createElement('span');
    el.className = 'wald-fs-glint';
    el.style.width = size + 'px';
    el.style.height = size + 'px';
    el.style.left = x.toFixed(1) + 'px';
    el.style.top = y.toFixed(1) + 'px';
    el.style.animation = 'waldFsGlint ' + (1.0 + Math.random() * 0.5).toFixed(2) + 's ease both';
    el.addEventListener('animationend', function () {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    layer.appendChild(el);
  }

  function isVisible(bar) {
    if (!document.contains(bar) || document.hidden) return false;
    if (bar.offsetParent === null) return false;
    var cs = window.getComputedStyle(bar);
    if (cs.visibility === 'hidden' || cs.display === 'none') return false;
    var r = bar.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function startGlints(bar) {
    bar.setAttribute('data-fsglint', '1');
    var layer = document.createElement('span');
    layer.className = 'wald-fs-glint-layer';
    bar.appendChild(layer);
    var angle = Math.random() * 360;

    (function tick() {
      // The bar gets replaced on cart re-renders — when this instance is detached, stop;
      // ensureGlints() will have already started a fresh one on the new bar.
      if (!document.contains(bar)) {
        if (layer.parentNode) layer.parentNode.removeChild(layer);
        return;
      }
      if (isVisible(bar)) {
        angle += 44 + Math.random() * 20; // advance around the word
        spawnGlint(bar, layer, angle);
      }
      setTimeout(tick, 430 + Math.random() * 150); // continuous, with small natural pauses
    })();
  }

  function ensureGlints() {
    injectCss();
    var bars = document.querySelectorAll(REACHED + ':not([data-fsglint])');
    for (var i = 0; i < bars.length; i++) startGlints(bars[i]);
  }

  function init() {
    ensureGlints();

    // Re-scan after cart changes (the bar re-renders), once pubsub is ready.
    (function attach(tries) {
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
            setTimeout(ensureGlints, 150);
            setTimeout(ensureGlints, 450);
          });
          return;
        }
      } catch (e) {}
      if (tries < 80) setTimeout(function () { attach(tries + 1); }, 100);
    })(0);

    // Catch the drawer opening on an already-qualifying cart (no cartUpdate fires then).
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () {
        setTimeout(ensureGlints, 350);
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    // Light safety net so a missed re-render path still gets glints (cheap query).
    setInterval(ensureGlints, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
